import { render, staticRenderFns } from "./CommonMessageModal.vue?vue&type=template&id=5f0235c7&scoped=true&"
import script from "./CommonMessageModal.vue?vue&type=script&lang=js&"
export * from "./CommonMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonMessageModal.vue?vue&type=style&index=0&id=5f0235c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0235c7",
  null
  
)

export default component.exports